import React from 'react'

const FractionalHeroSection = () => {
    return (
        <div className='pl5rem pr5rem pt0rem pb0rem df aic jcc pr FractionalHeroSection'>
            <div className='w70 pt2rem'>
                <div className='df fdc aifs jcfs w80'>
                    <p className='w100 c15 tal mb1 rem fs1-5rem fw400'>The Platform for Fractional CFOs</p>
                    <h1 className='w100 c15 tal fw500 fs3rem md-fs2rem'>Organise Clients, Increase Billables and Win New Business</h1>
                    <p className='w100 c15 tal mt1rem fs1rem fw400' style={{ letterSpacing: 1 }}>Our AI-driven platform streamlines your workflow, gets clients transaction-ready, increases their value, and introduces you to your next high-growth opportunity</p>
                    <div className='w100 tal mt1rem'>
                        <a target='_blank' href='https://koalendar.com/e/meet-with-mark-bernstein' className='cp c1 bg4 bg3-hover br50px fw400 fs0-75rem zi0 td250' style={{
                            padding: '0.5rem 1rem'
                        }}>Book a Demo</a>
                    </div>
                </div>
            </div>
            <div className='w30 pr'>
                <img className='w100' src={require('../../../../images/fractional/fractional.png')} alt='fractional-hero-section' />
                <img className='w100 pa' style={{
                    right: '-10%',
                    bottom: '10%'
                }} src={require('../../../../images/fractional/namePlate.svg')} alt='namePlate-hero-section' />

            </div>
        </div>
    )
}

export default FractionalHeroSection